import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function LifeCycleModule() {
  return <ModuleNavigation moduleId="LifeCycleModule" />;
}
